// can't backward compatible,
// please update it if you want to backward compatible
// Capacitance Pressure Id : Source : 0 ,vacuum :1, Bottle:2
// Load cell Pressure Id : SOURCE : 0, VACUUM : 1,BOTTLE : 3,DIAPHRAGM : 2

export const PRESSURIZED_CODE = {
  PRESSURIZED: {
    NAME: "PRESSURIZED",
    CODE: -1,
  },
  DEPRESSURIZED: {
    NAME: "DEPRESSURIZED",
    CODE: -2,
  },
};

export const SET_POINT_TOLERANCE = 50; // %

/**
 * @enum {String}
 */
// TODO: the enum type naming is redundant with PRESSURE_TYPE on .\PC.Client\DebugApp\Components\content\pressureControl\Pressure.js
export const PRESSURE_TYPE = {
  HI: "Hi",
  LO: "Lo",
};

/**
 * @enum {String}
 */
export const PRESSURE_TYPE_LABEL = {
  [PRESSURE_TYPE.HI]: "High Pressure",
  [PRESSURE_TYPE.LO]: "Low Pressure",
};

export const PRESSURE_LABEL = "Pressure";

export const PRESSURE_PARAMETER_LIMIT = {
  HI: {
    BOTTLE_PRESSURE: {
      MAX_VALUE: 21,
      MIN_VALUE: 0,
    },
    DIAPHRAGM_PRESSURE: {
      MAX_VALUE: 40,
      MIN_VALUE: 10,
    },
  },
  LOW: {
    BOTTLE_PRESSURE: {
      MAX_VALUE: 50,
      MIN_VALUE: 10,
    },
    DIAPHRAGM_PRESSURE: {
      MAX_VALUE: 40,
      MIN_VALUE: 10,
    },
  },
};
